import { isValid } from "date-fns";
import { useRouter } from "next/router";
import { useClientBookingContext } from "@/contexts/clientBookingContext";
import { BookingStep } from "@/types/bookingTypes";
import { useSelectiveEffect } from "../misc/useSelectiveEffect";

export default function useUpdateBookingUrl() {
  const { query, push } = useRouter();
  const { slug } = query;
  const {
    step,
    selectedServices,
    selectedProvider,
    date,
    timeSlot,
    clientDetails,
    isReturningClient,
    isFds,
  } = useClientBookingContext();

  useSelectiveEffect(() => {
    if (slug) {
      const serviceIdsQuery =
        selectedServices.length > 0
          ? {
              serviceIds: selectedServices
                .map((service) => service.id)
                .join(","),
            }
          : {};
      // prevents skipping provider step while refreshing on services step
      const shouldSaveProvider = step !== BookingStep.SERVICES;
      const providerIdQuery =
        shouldSaveProvider && selectedProvider
          ? { providerId: selectedProvider.id }
          : {};
      const dateQuery = isValid(new Date(date))
        ? { date: date.toISOString() }
        : {};
      const timeSlotQuery = timeSlot
        ? { startStr: timeSlot.startStr, endStr: timeSlot.endStr }
        : {};
      const completedQuery =
        step === BookingStep.BOOKED ? { completed: true } : {};

      const clientDetailsQuery = clientDetails || {};

      const returningClientQuery = isReturningClient
        ? { returningClient: true }
        : {};

      const isFdsQuery = isFds ? { isFds: "true" } : {};

      // Remove slug from query. Next.js includes this because this is a dynamic route
      const { slug, ...queryParamsWithoutSlug } = query;

      const updatedQuery = {
        // keep existing query params
        // IMPORTANT FOR UTM PARAMS: do not remove
        ...queryParamsWithoutSlug,
        // override the following query params
        ...serviceIdsQuery,
        ...providerIdQuery,
        ...timeSlotQuery,
        ...dateQuery,
        ...clientDetailsQuery,
        ...returningClientQuery,
        ...isFdsQuery,
        ...completedQuery,
      };

      push({ pathname: `/booking/${slug}`, query: updatedQuery }, undefined, {
        shallow: true,
      });
    }
  }, [
    slug,
    step,
    date,
    isFds,
    timeSlot,
    clientDetails,
    selectedServices,
    selectedProvider,
    isReturningClient,
  ]);
}
